export const booleanFormatter = (value: boolean | undefined) => {
  if (typeof value === "boolean") return value ? "Yes" : "No";

  return "-";
};
